import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FETCH_SEASON_LEADERS } from '../../../../../store/js/modules/statspro/season-leaders/actions';
import { seasonLeadersDataSelector } from '../../../../../store/js/modules/statspro/season-leaders/selectors/data-selector';
import { SeasonLeadersCard } from './components/SeasonLeadersCard';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { SvgIcon } from '../../../../../../../common/react/components/SvgIcon';
import { BREAKPOINTS_FOR_FOUR_SLIDES, sliderSettings } from '../../../settings/slider';
import classNames from 'classnames';

export const SeasonLeadersSlider = ( { seasonId, compseasonId } ) => {
    const dispatch = useDispatch();
    const data = useSelector( seasonLeadersDataSelector );
    const sliderName = 'season-leaders';

    useEffect( () => {
        dispatch( FETCH_SEASON_LEADERS.request( { seasonId } ) );
    }, [] );

    return (
        <div className={ classNames( 'season-leaders statspro-slider fade-in-on-load', {
            'is-loaded': !!data?.displayOrder?.length
        } ) }>
            <Swiper { ...sliderSettings( sliderName ) } { ...BREAKPOINTS_FOR_FOUR_SLIDES }>
                { data?.displayOrder?.map( ( category, i ) => (
                    <SwiperSlide key={ i }>
                        <SeasonLeadersCard
                            players={ data[ category ] }
                            compseasonId={ compseasonId }
                        />
                    </SwiperSlide>
                ) ) }
            </Swiper>
            <div className={ `swiper-button-prev swiper-button-prev-unique-${ sliderName }` }>
                <SvgIcon
                    icon="chevron"
                    className="icon"
                />
            </div>
            <div className={ `swiper-button-next swiper-button-next-unique-${ sliderName }` }>
                <SvgIcon
                    icon="chevron"
                    className="icon"
                />
            </div>
        </div>
    );
};

SeasonLeadersSlider.propTypes = {
    seasonId: PropTypes.string.isRequired,
    compseasonId: PropTypes.string.isRequired
};